/** Suppress map/backdrop side-effects while the OS gallery/camera picker is open. */
const SUPPRESS_AFTER_MS = 2000;

let pickerActiveUntil = 0;

export function markPicturePickerActive(): void {
  pickerActiveUntil = Date.now() + SUPPRESS_AFTER_MS;
}

/** Call when the picker returns a file (extends the suppress window for ghost clicks). */
export function markPicturePickerReturned(): void {
  pickerActiveUntil = Date.now() + SUPPRESS_AFTER_MS;
}

export function isPicturePickerActive(): boolean {
  return Date.now() < pickerActiveUntil;
}
